import React from "react";
import ListBoxItem from "../../../../../../components/molecules/ListBoxItem/ListBoxItem";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";
import "./spendingDemandListView.scss";
import EmptyListIcon from "../../../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Table from "../../../../../../components/molecules/Table/Table";
import StatusBox from "../../../../../../components/atoms/StatusBox/StatusBox";
import { IconType } from "../../../../../../assets/JWayIcons";
import { limitString } from "../../../../../../utils/stringUtils";
import BoxInfo from "../../../../../boxAssociation/components/BoxInfo";
import Tooltip from "../../../../../../components/atoms/Tooltip/Tooltip";

export interface ItemSpending {
  id: string;
  title?: string;
  userFirstName?: string 
  userLastName?: string 
  userFullNameRenderer?: () => React.ReactNode;
  projectNameRenderer?: () => React.ReactNode;
  creditTotalRenderer?: () => React.ReactNode;
  spendingTotalRenderer?: () => React.ReactNode;
  collabPayedRenderer?: () => React.ReactNode;
  orgPayedRenderer?: () => React.ReactNode;
  acompteRenderer?: () => React.ReactNode;
  date?: string;
  createdDate?: string;
  grossAmmount?: number;
  status?: string;
  pinColor?: string;
  withPin?: boolean;
  isChecked?: boolean;
  colorStatus?: {
    backgroundColor?: string;
    color?: string;
    iconType?: IconType;
  };
  projectName?: string;
  spendingDemandType?: string;
  boxId?: string;
  spendingDemandLastTeamFrom?: string;
  spendingDemandComptableTeam?: string;
  spendingDemandReadableId?: string;
  onCheck?: () => void;
  onClick?: () => void;
}
export interface SpendingDemandListViewProps {
  spendingList: ItemSpending[];
  emptyMessage?: string;
  isCheckMode?: boolean;
  noUser?: boolean;
  onSelectAll?: () => void;
  onUnselectAll?: () => void;
  isAllSelected?: boolean;
  isSomeSelected?: boolean;
  totalCount?: number;
}

export const SpendingDemandListViewV2 = ({
  spendingList,
  emptyMessage,
  isCheckMode,
  noUser,
  onSelectAll,
  onUnselectAll,
  isAllSelected,
  isSomeSelected,
  totalCount = 0
}: SpendingDemandListViewProps) => {
  // Vérifier si au moins une spending demand a un projet
  const hasProject = spendingList.some(spending => 
    spending.projectName || spending.projectNameRenderer
  );

  // Vérifier si au moins une spending demand a un boxId (type BOX)
  const hasBoxId = spendingList.some(spending => 
    spending.spendingDemandType === 'BOX' && spending.boxId
  );

  // Vérifier si au moins une spending demand a un readable ID
  const hasReadableId = spendingList.some(spending => 
    spending.spendingDemandReadableId
  );

  return (
    <div>
      {totalCount !== undefined && totalCount > 0 && (
        <div style={{
          fontSize: '0.75rem',
          color: '#999',
          marginBottom: '10px'
        }}>
          {totalCount} {totalCount > 1 ? 'demandes de dépense trouvées' : 'demande de dépense trouvée'}
        </div>
      )}
      <Table
        emptyMessage={'Aucune demande de dépense'}
        withCheckCase={isCheckMode}
        onSelectAll={onSelectAll}
        onUnselectAll={onUnselectAll}
        isAllSelected={isAllSelected}
        isSomeSelected={isSomeSelected}
        headerTitle={[
          "Description",
          hasReadableId ? "ID" : undefined,
          "Créer le",
          "Montant demandé",
          "Montant crédité",
          "Payé par collaborateur",
          "Payé",
          "Acompte",
          "Montant des dépenses",
          noUser ? undefined : "Utilisateur",
          hasProject ? "Projet" : undefined,
          "Type",
          hasBoxId ? "Box ID" : undefined,
          "Statut"
        ].filter((item) => item !== undefined) as string[]
      }
        bodyData={spendingList.map((spending) => {
          const rowData = [
            () => (
              <Tooltip content={spending.title}>
                <span>{limitString(spending.title, 20)}</span>
              </Tooltip>
            ),
            hasReadableId ? (spending.spendingDemandReadableId || "") : undefined,
            spending.createdDate,
            numberToStingWithSpaces(spending.grossAmmount || 0),
            spending.creditTotalRenderer ? spending.creditTotalRenderer : () => <span style={{ color: '#999' }}>-</span>,
            spending.collabPayedRenderer ? spending.collabPayedRenderer : () => <span style={{ color: '#999' }}>-</span>,
            spending.orgPayedRenderer ? spending.orgPayedRenderer : () => <span style={{ color: '#999' }}>-</span>,
            spending.acompteRenderer ? spending.acompteRenderer : () => <span style={{ color: '#999' }}>-</span>,
            spending.spendingTotalRenderer ? spending.spendingTotalRenderer : () => <span style={{ color: '#999' }}>-</span>,
            noUser ? undefined : spending.userFullNameRenderer ? spending.userFullNameRenderer() : ((spending.userFirstName ?? '') + " " + (spending.userLastName ?? '')).trim() || '-',
            hasProject ? (spending.projectNameRenderer ? spending.projectNameRenderer() : limitString(spending.projectName, 20) || "") : undefined,
            spending.spendingDemandType === 'PROJECT' ? 'Projet' : 
            spending.spendingDemandType === 'BOX' ? 'Box' : 
            spending.spendingDemandType === 'CURRENT' ? 'Courante' : '',
            hasBoxId ? (spending.spendingDemandType === 'BOX' && spending.boxId ? 
              () => <BoxInfo boxAssociationId={spending.boxId} info="BoxId" emptyText="" limitText={15} /> : 
              "") : undefined,
            () => (

              <StatusBox
              
                color={{
                  background: spending.colorStatus?.backgroundColor,
                  text: spending.colorStatus?.color,
                }}
               iconType={ spending.colorStatus?.iconType}
                size={{
                    height: "20px",
                    font: "0.7rem",
                    width: "100px",
                    lineHeight: "0.8rem"
                    
                    
                }}
              >
                {spending.status}
              </StatusBox>
            ),
          ].filter((item) => item !== undefined) as any[];

          return {
            id: spending.id,
            onRowClick: spending.onClick,
            onCheck: spending.onCheck,
            isChecked: spending.isChecked,
            data: rowData,
          };
        })}
      />
    </div>
  );
};

export function SpendingDemandListView({
  spendingList,
  emptyMessage,
  isCheckMode,
  totalCount
}: SpendingDemandListViewProps) {
  if (emptyMessage && spendingList.length === 0) {
    return <EmptyListIcon message={emptyMessage} marginTop={"80px"} />;
  }
  return (
    <>
      {totalCount !== undefined && totalCount > 0 && (
        <div style={{
          fontSize: '0.75rem',
          color: '#999',
          marginBottom: '10px'
        }}>
          {totalCount} {totalCount > 1 ? 'demandes de dépense trouvées' : 'demande de dépense trouvée'}
        </div>
      )}
      <ul className="spending-list">
        {spendingList.map((spending, index) => (
          <li className="spending-list-item" key={spending.id || index}>
            <ListBoxItem
              titleSize="1.1rem"
              headerTitleLeft={spending.createdDate}
              titleLeft={spending.title}
              subTitleLeft={((spending.userFirstName ?? '') + " " + (spending.userLastName ?? '')).trim() || '-'}
              titleRight={
                "- " + numberToStingWithSpaces(spending.grossAmmount || 0)
              }
              titleLabelRight="FCFA"
              subTitleRight={spending.status}
              pinColor={spending.pinColor}
              withPin={spending.withPin}
              linkTo={
                !isCheckMode ? "/spending_demand/" + spending.id : undefined
              }
              handleClick={isCheckMode ? spending.onCheck : undefined}
              colorSubTitleRight={spending.colorStatus}
              withCheckCase={isCheckMode}
              isChecked={spending.isChecked}
              onCheck={spending.onCheck}
              
            />
          </li>
        ))}
      </ul>
    </>
  );
}

export default SpendingDemandListViewV2;
